import {CompanyStatistics} from '@/types/company';
import {Box, Grid, SxProps, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface CompanyStatisticsComponentProps {
  companyStatistics: CompanyStatistics;
  sx?: SxProps;
}

const CompanyStatisticsComponent: React.FC<CompanyStatisticsComponentProps> = ({
  companyStatistics,
  sx
}) => {
  const {t} = useTranslation();

  return (
    <Box sx={sx}>
      <Grid item xs={12} marginBottom={3.5}>
        <Typography variant="body1" gutterBottom>
          {t('event_count')}: <strong>{companyStatistics.events.total}</strong>
        </Typography>
      </Grid>
      <Grid item xs={12} marginBottom={3.5}>
        <Typography variant="body1" gutterBottom>
          {t('group_count')}: <strong>{companyStatistics.teams.total}</strong>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" gutterBottom>
          {t('user_count')}: <strong>{companyStatistics.users.total}</strong>
        </Typography>
      </Grid>
    </Box>
  );
};

export default CompanyStatisticsComponent;
